import { SelectItem } from '@core/models/select.model';

export enum LANGUAGES {
  EN_US = 'en-US',
  PT_BR = 'pt-BR',
}

export const languages: SelectItem[] = [
  { value: LANGUAGES.EN_US, label: 'English' },
  { value: LANGUAGES.PT_BR, label: 'Português' },
];
